import { apiCall } from "../api";

import ClientDto from '../../DTOs/Client/ClientDto.js';
import DemographicSchemasDto from '../../DTOs/Organization/DemographicSchemasDto.js';
import KeywordListDto from '../../DTOs/Keyword/KeywordListDto';
import MeasureDto from '../../DTOs/Measure/MeasureDto';
import RecaptchaResponseDto from '../../DTOs/Recaptcha/RecaptchaResponseDto';
import UnknownClientMeasureDataDto from "../../DTOs/Measure/UnknownClientMeasureDataDto";
import ProgramMeasureDataDto from "../../DTOs/Measure/ProgramMeasureDataDto";

const requestOptions = { anonymous: true };

export const getAllKeywords = async () => {
  let url = 'externalform/keywords';
  let response = await apiCall(url, requestOptions);
  return new KeywordListDto(response.result);
}

export const getDemographicSchemas = async(formId) =>{
  const url = `externalform/clientform/${formId}`;
  let response = await apiCall(url, requestOptions);
  return new DemographicSchemasDto(response.result);
}

export const addClient = async(formId, dto) => {
  const url = `externalform/addclient/${formId}`;
  let response = await apiCall(url, { method: 'POST', body: dto, anonymous: true });
  return new ClientDto(response.result);
}

export const getClientMeasureAsync = async (formId) => {
  const url = `externalform/clientmeasuredataform/${formId}`;
  let response = await apiCall(url, requestOptions);
  return new MeasureDto(response.result);
}

export const addClientMeasureDataAsync = async (formId, dto) => {
  const url = `externalform/addClientMeasureData/${formId}`;
  let response = await apiCall(url, { method: 'POST', body: dto.stringify(), anonymous: true });
  return new UnknownClientMeasureDataDto(response.result);
}

export const getProgramMeasureAsync = async (formId) => {
  const url = `externalform/programmeasuredataform/${formId}`;
  let response = await apiCall(url, requestOptions);
  return new MeasureDto(response.result);
}

export const addProgramMeasureDataAsync = async (formId, dto) => {
  const url = `externalform/addProgramMeasureData/${formId}`;
  let response = await apiCall(url, { method: 'POST', body: dto.stringify(), anonymous: true });
  return new ProgramMeasureDataDto(response.result);
}

export const validateRecaptcha = async(dto) => {
  const url = `externalform/validateRecaptcha`;
  let response = await apiCall(url, { method: 'POST', body: dto.stringify(), anonymous: true });
  return new RecaptchaResponseDto(response.result);
}
